// @em/ui — injected icon registry.
//
// AppIcon renders icons by string name from a registry the CONSUMER provides at
// startup via `configureIcons(...)`. That keeps the (large) generated icon bundle
// app-owned and right-sized per consumer, so @em/ui carries no icon set of its own
// and no @tabler dependency. Same injection pattern as @em/api's client.
import type React from "react";

export type IconComponentType = React.ComponentType<any>;
export type IconRegistryType = Record<string, IconComponentType>;

let registry: IconRegistryType = {};
let fallback: IconComponentType | null = null;

/** Register the app's generated icon set (+ optional fallback) once at startup,
 *  before any AppIcon renders. */
export const configureIcons = (reg: IconRegistryType, fallbackIcon?: IconComponentType): void => {
  registry = reg || {};
  if (fallbackIcon) {
    fallback = fallbackIcon;
  }
};

export const getIconRegistry = (): IconRegistryType => registry;
export const getFallbackIcon = (): IconComponentType | null => fallback;
export const hasIcon = (name: string): boolean => !!registry[name];
